import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../../dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../../dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorPlanProtectionDialogComponent } from '../../../app/dialogs/visualizador-plan-protecion/visualizador-plan-protection-dialog.component';

@Component({
  selector: 'plan-protection-consulta',
  templateUrl: './plan-protection-consulta.html',
  styleUrls: ['./plan-protection-consulta.scss']
})

export class PlanProtectionConsultaComponent { 

  @ViewChild('customTemplate', { static: true }) customTemplate: TemplateRef<any>;
  @ViewChild('vendedorTemplate', { static: true }) vendedorTemplate: TemplateRef<any>;

  filtros = true
  isLoadingView: boolean = false
  total: number;
  filter = new FormControl();
  selectFilter = new FormControl();
  page: number = 1;
  pageSize: number = 20;
  elements$: Observable<any>
  pag: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  paginator$ = this.pag.asObservable();
  sort: any = { active: "position", direction: 'desc' };
  isLoadingResults = true;
  listaProveedores = []
  estatus = []
  activeFilter = 1
  folioFilter = ''
  clienteFilter = ''
  celularFilter = ''
  placasFilter = ''
  sucursalFilter = ''
  ovFilter = ''
  estatusFilter = ''
  sucfiLTER = ''
  columns = []
  rows = [];
  temp = [];
  ColumnMode = ColumnMode;
  code1: any;
  sucursales = []
  sucursalesFiltradas = []
  selectedOptionsSucursales = [];
  filtroSucursal
  firstAccess = true
  filtroReset = false

  elementos = [20, 40, 100]
  paginator: IPaginator = { itemsPerPage: 40, pageNumber: 1 }
  pagination: IPagination;
  pages: Array<any> = [];
  filters: any = {};
  columnas: Array<any> = [
    {
      title: "Folio PP", key: "folio", orderby: "folioPP"
    },
    {
      title: "Estatus", key: "estatus", orderby: "estatus"
    },
    {
      title: "Orden Venta", key: "ordenVentaId", orderby: "ordenVentaId"
    },
    {
      title: "Sucursal", key: "sucursal", orderby: "sucursal"
    },
    {
      title: "Nombre Cliente", key: "nombreCliente", orderby: "nombreCliente"
    },
    {
      title: "Placas", key: "placas", orderby: "placas"
    },
    {
      title: "Celular Cliente", key: "celular", orderby: "celular"
    },
    {
      title: "Fecha Venta", key: "fechaVenta", orderby: "fechaVenta"
    },
    {
      title: "Fecha de Expiración", key: "fechaVigencia", orderby: "fechaVigencia"
    }
  ]

  constructor(private ppService: PlanProtectionService, private dialog: MatDialog, private cdr: ChangeDetectorRef, private spinnerService: SpinnerService){
    this.getEstatus()
    this.getSucursales()
  }

  filtrarSucursales() {
    this.sucursalesFiltradas = this.sucursales.filter(s =>
      s.nombreSucursal.toLowerCase().includes(this.filtroSucursal.toLowerCase())
    );
  }

  getEstatus(){
    this.ppService.getEstatusPP().subscribe(
      data => {
        this.estatus = data
      }
    )
  }

  isGerente(){
    return localStorage.getItem('profile') === 'Gerente'
  }
  ngOnInit(): void {
    if(this.isGerente()){
      let vendedorColumn = {
        title: "Nombre Vendedor", key: "nombreVendedor", orderby: "nombreVendedor"
      }
      this.columnas.splice(1, 0, vendedorColumn)
    }

    const obsFilter = this.filter.valueChanges.pipe(
      debounceTime(200),
      startWith(null),
      switchMap((res: string) => this.ppService.getLength(res)),
      tap((res: number) => {
        this.total = res;
      })
    );

    this.elements$ = merge(obsFilter, this.paginator$)
      .pipe(
        distinctUntilChanged(),
        tap(_ => { this.isLoadingResults = true }),
        switchMap(res => {
          return this.ppService.getData(
            this.page,
            this.pageSize,
            // this.filter.value,
            this.sort.active,
            this.sort.direction
          );
        }),
        tap(_ => (this.isLoadingResults = false))
      )

  }

  getSucursales(){
    this.ppService.getSucursales({}).subscribe(
      data => {
        this.sucursales = data
        const idsGuardados: number[] = JSON.parse(localStorage.getItem('sucursalId') || '[]');
        const sucursalesFiltradas = this.sucursales.filter(sucursal =>
          idsGuardados.includes(sucursal.sucursalId)
        );
        this.sucursalesFiltradas = this.sucursales
        this.selectedOptionsSucursales = sucursalesFiltradas
        this.getData(1)
      }
    )
    
  }
  
  getData(opc){

    this.spinnerService.setMensaje('Cargando Plan Protection Vigentes')
    this.spinnerService.show()
    let body = {
      // empresaId: parseInt(localStorage.getItem('empresaId')),
      vendedorId: parseInt(localStorage.getItem('id')),
      empresaId: 0
      // vendedorId: 0
    }

    if(this.ovFilter !== ''){
      body['ordenVentaId'] = this.ovFilter
      body['vendedorId'] = 0
    }

    if(this.clienteFilter !== ''){
      body['cliente'] = this.clienteFilter
      body['vendedorId'] = 0
    }

    if(this.folioFilter !== ''){
      body['folio'] = this.folioFilter
      body['vendedorId'] = 0
    }

    if(this.celularFilter !== ''){
      body['celular'] = this.celularFilter
      body['vendedorId'] = 0
    }

    if(this.placasFilter !== ''){
      body['placas'] = this.placasFilter
      body['vendedorId'] = 0
    }

    if(this.estatusFilter !== ''){
      body['estatus'] = this.estatusFilter
      body['vendedorId'] = 0
    }

    if(this.selectedOptionsSucursales.length > 0){
      let sucursales = []
      this.selectedOptionsSucursales.forEach(element => {
        sucursales.push(element.sucursalId)
      });
      body['sucursalIdList'] = sucursales
      // if(!this.firstAccess){
      body['vendedorId'] = 0
      // }
    }

    if(this.filtroReset){
      this.paginator.page = 1;
      this.paginator.pageNumber = 1;
    }
    body['paginacion'] = this.paginator;

    this.ppService.getListaPlanProtectionVigente(body).subscribe(
      data => {
        this.listaProveedores = data.datos.items
        this.ppService.setData(this.listaProveedores);
        this.pagination = data.datos.paginacion;
        this.configurarPaginas(4);
        this.code1 = this.ppService.getInfo()
        setTimeout(() => {
          this.isLoadingView = true
          this.firstAccess = false
          this.filtroReset = false
          this.spinnerService.hide()
        }, 500);
      }, err => {

        this.spinnerService.hide()
      }
    )

   
    // if(opc === 2){
    //   if(this.nameFilter !== '' || this.lastNameFilter !== '' || this.emailFilter !== '' || this.userNameFilter !== ''){
    //     this.getDataEndpoint()
    //   }else{
    //     return
    //   }
    // }else{
    //   this.getDataEndpoint()
    // }
  }

  editarRegistro(item){
    const dialogRef = this.dialog.open(VisualizadorPlanProtectionDialogComponent, {
      panelClass: 'custom-dialog',
      disableClose: true,
      height: '100vh',
      width: window.screen.width < 700 ? '100vw' : '700px',
      data: {
        planProtection: item
      }
    });
    dialogRef.afterClosed().subscribe(async result =>  {
      
      if (result.event !== 1) {
        return
      }else{
        let event = {
          type: 'click',
          row: {
            id: result.user.id
          }
        }
        await this.getData(1)
        this.editarRegistro(event)
      }

    });
    
  }

  showAdmin(){
    return localStorage.getItem('profile') === '1' ? true : false
  }

  mostrarFiltros(){
    this.filtros = !this.filtros
  }

  toggleAllSucursales(event) {
		
    if (event.checked) {
        this.selectedOptionsSucursales = this.sucursales.map(sucursal => sucursal);			
    } else {
        this.selectedOptionsSucursales = [];			
    }

		setTimeout(() => {
			// this.getVendedoresDeSucusales()
		}, 1000);
  }

  isAllSelectedSucursales() {
		if (this.sucursales != undefined)
		{
			return this.selectedOptionsSucursales.length === this.sucursales.length;
		}
		return false;
  }

  isIndeterminateSucursales() {
    return this.selectedOptionsSucursales.length > 0 && this.selectedOptionsSucursales.length < this.sucursales.length;
  }

  private configurarPaginas(numPages: number) {
    const { floor, min, max } = Math
    const range = (lo, hi) => Array.from({ length: hi - lo }, (_, i) => i + lo)
    const pagination = (count) => (page, total) => {
      const start = max(1, min(page - floor((count - 3) / 2), total - count + 2))
      const end = min(total, max(page + floor((count - 2) / 2), count - 1))
      return [
        ... (start > 2 ? [1, '...'] : start > 1 ? [1] : []),
        ...range(start, end + 1),
        ... (end < total - 1 ? ['...', total] : end < total ? [total] : [])
      ]
    }

    const pages = pagination(numPages)(this.pagination.currentPage, this.pagination.totalPages);
    let prevPage = 0;
    this.pages = [];
    pages.map((page, index) => {
      const pageInfo: any = {
        id: (page == '...' ? prevPage + 1 : page),
        text: page
      };
      pageInfo.title = `Página ${pageInfo.id}`;
      this.pages.push(pageInfo);
      if (page != '...') {
        prevPage = parseInt(page);
      }
    });
  }

  gotoPage(page: any) {
    switch (page) {
      case '<':
        page = this.pagination.currentPage - 1;
        break;
      case '>':
        page = this.pagination.currentPage + 1;
        break;
    }
    this.paginator.page = page;
    this.paginator.pageNumber = page;
    this.getData(1);
  }

  cambioDropdown(event) {
    this.paginator.itemsPerPage = event
    this.getData(1)
  }

  paginaSeleccionada(event){
    this.paginator.page = event;
    this.paginator.pageNumber = event;
    this.getData(1)
  }

  setearFiltroReset(){
    this.filtroReset = true
  }
}
